/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Fix Globo : scroll auto vers le haut de la grille produits, uniquement après un clic sur un filtre
(function() {
  var productsContainer = document.querySelector('#gf-products');
  if (!productsContainer) return;

  var isScrolling = false;
  var filterClicked = false;

  function scrollToProducts() {
    if (isScrolling) return;
    isScrolling = true;

    setTimeout(function() {
      // On cible le conteneur global (filtres + résultats), pas juste la grille produits
      var scrollTarget = document.querySelector('#gf-grid') || productsContainer;
      // Marge supplémentaire pour ne pas coller le haut du bloc filtres au header
      var headerOffset = window.innerWidth >= 992 ? 140 : 110;
      var targetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      isScrolling = false;
    }, 100);
  }

  // On observe en permanence, mais on ne scroll QUE si un filtre vient d'être cliqué
  var observer = new MutationObserver(function() {
    if (filterClicked) {
      filterClicked = false; // reset immédiat pour n'agir qu'une fois
      scrollToProducts();
    }
  });

  observer.observe(productsContainer, { childList: true, subtree: false });

  // On détecte le clic sur un élément de filtre Globo
  // #gf-tree = bloc filtres desktop, #gf-controls-container = bloc filtres mobile
  document.addEventListener('click', function(e) {
    if (e.target.closest('#gf-tree') || e.target.closest('#gf-controls-container')) {
      filterClicked = true;
    }
  });
})();